// import React from "react";
// import { Dialog, DialogContent, Typography, Button, Box } from "@mui/material";

// export default function RoleSelectionDialog({ open, onSelect }) {
//   return (
//     <Dialog
//       open={open}
//       PaperProps={{
//         sx: {
//           borderRadius: 3,
//           p: 4,
//           textAlign: "center",
//         },
//       }}
//     >
//       <DialogContent>
//         <Typography variant="h5" mb={3}>
//           Register as
//         </Typography>
//         <Box display="flex" justifyContent="center" gap={2}>
//           <Button
//             variant="contained"
//             size="large"
//             onClick={() => onSelect("therapist")}
//           >
//             Therapist
//           </Button>
//           <Button
//             variant="outlined"
//             size="large"
//             onClick={() => onSelect("patient")}
//           >
//             Patient
//           </Button>
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// }

import React from "react";
import { Dialog, DialogContent, Typography, Button, Box } from "@mui/material";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import PersonIcon from "@mui/icons-material/Person";

export default function RoleSelectionDialog({ open, onSelect }) {
  return (
    <Dialog
      open={open}
      maxWidth="sm" // wider dialog
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: { xs: 0, md: 4 },
          textAlign: "center",
          boxShadow: 6,
        },
      }}
    >
      <DialogContent>
        <Typography variant="h4" fontWeight="bold" mb={1}>
          Welcome to EKKO
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={4}>
          Do you want to register as a patient or a therapist?
        </Typography>

        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="center"
          gap={{ xs: 1, md: 3 }}
        >
          <Button
            variant="contained"
            size="large"
            startIcon={<PersonIcon />}
            onClick={() => onSelect("patient")}
            sx={{
              px: 4,
              py: 1,
              borderRadius: 2,
              fontSize: "1rem",
            }}
          >
            Patient
          </Button>

          <Button
            variant="outlined"
            size="large"
            startIcon={<LocalHospitalIcon />}
            onClick={() => onSelect("therapist")}
            sx={{
              px: 4,
              py: 1,
              borderRadius: 2,
              fontSize: "1rem",
            }}
          >
            Therapist
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
